// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  // Url of the Identity Provider
  issuer: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7',

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin,

  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: 'nike.cis.mfa-enrollment',

  // set the scope for the permissions the client should request
  scope: 'openid profile email groups',

  apiUrl: 'https://mfa-api.cis-iam-okta-test.nikecloud.com',

  adminGroups: [
    'Application.Okta.MFA_Admins'
  ],

  userSettingsLink: 'https://nike-qa.oktapreview.com/account-settings/security',

  redirectLinks: {
    faq: 'https://niketech.service-now.com/nav_to.do?uri=%2Fkb_view_customer.do%3Fsys_kb_id%3Ddcf9f2fcdbc8978437a09bc5ca9619db'
  }
};

